import React, { Component } from 'react';
import { Login } from './api-authorization/Login';
import { NavMenu } from './NavMenu';
import { Sidebar } from './Sidebar';
import authService from './api-authorization/AuthorizeService';
import { LoginActions } from './api-authorization/ApiAuthorizationConstants';

export class Layout extends Component {
  static displayName = Layout.name;
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            isAuthenticated: false,
            user: null
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            user: user,
            loading: false
        });
    }

    render() {
        const { loading, isAuthenticated, user } = this.state;
        if (loading) {
            return null;
        }
        if (!isAuthenticated) {            
            return this.loginView();
        } else {            
            return this.authenticatedView(user);
        }
    }

    loginView() {
        return (
            <div className="min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased bg-white text-black">
                <NavMenu />                
                <Login action={LoginActions.Login} />
            </div>
        );
    }

    authenticatedView (user) {
    return (
        <div className="min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased bg-gray-100 text-black">
            <NavMenu user={user} />
            <Sidebar user={user}/>           
            <div className="h-full ml-14 mt-14 mb-16 md:ml-40 2xl:ml-64">
                {this.props.children}
            </div>
      </div>
    );
  }
}
